import React, { Component } from "react";
import classNames from "classnames";
import DateFnsUtils from "@date-io/date-fns";
import { withStyles } from "@material-ui/core";
import { DatePicker as MuiDatePicker, MuiPickersUtilsProvider } from "material-ui-pickers";
import { FormField } from "react-form";

const styles = theme => ({
    rootLabel: {
        marginLeft: 12,
        marginTop: 3,
        whiteSpace: "nowrap"
    },
    rootLabelShrink: {
        marginLeft: 0,
        marginBottom: -6,
        position: "relative",
        whiteSpace: "normal"
    },
    bootstrapInput: {
        borderRadius: 4,
        border: "1px solid #979797",
        padding: "8px 12px",
        width: "calc(100% - 24px)",
        transition: theme.transitions.create(["border-color", "box-shadow"]),
        "&:focus": {
            boxShadow: "0 0 0 0.2rem rgba(0,64,110,.50)"
        },
        backgroundColor: "#fff",
        fontSize: 14,
        fontWeight: 300
    },
    bootstrapInputError: {
        "& input": {
            border: "1px solid #be0000"
        }
    },
    disabled: {
        backgroundColor: "#EEEEEE"
    },
    tableFormat: {
        padding: "4px 6px !important"
    },
});

class DatePickerWrapper extends Component {
    // The first commit of Material-UI
    //const [selectedDate, setSelectedDate] = React.useState(new Date());

    handleDateChange = date => {
        const { fieldApi, eventHandle } = this.props;
        const { setValue, getFieldName } = fieldApi;


        if (date) {
            const dateFns = new DateFnsUtils();
            var db_format = dateFns.format(date, "yyyy-MM-dd");

            setValue(db_format + " 12:00:00");
            if (eventHandle) eventHandle(db_format + " 12:00:00", getFieldName());
        } else {
            setValue(null);
            if (eventHandle) eventHandle(null, getFieldName());
        }
    };

    render() {
        const { label, helperText, fieldApi, classes, disabled, tableFormat, ...rest } = this.props;
        const { getValue, getError, getWarning, getSuccess } = fieldApi;
        var value = getValue(),
            error = getError(),
            warning = getWarning(),
            success = getSuccess(),
            hasError = !!error,
            errorText = error || warning || success || helperText;

        let InputProps = {};
        InputProps["disableUnderline"] = true;
        InputProps["classes"] = {
            input: classNames(classes.bootstrapInput, disabled && classes.disabled, tableFormat && classes.tableFormat,),
            error: classes.bootstrapInputError
        };

        return (
            <>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <MuiDatePicker
                        id="date-picker"
                        label={label}
                        clearable
                        value={value !== undefined ? value : null}
                        onChange={this.handleDateChange}
                        openTo="year"
                        views={["year", "month", "day"]}
                        format="MMMM d, yyyy"
                        autoOk
                        disabled={disabled}
                        InputProps={InputProps}
                        InputLabelProps={{
                            shrink: true,
                            classes: {
                                root: classes.rootLabel,
                                shrink: classes.rootLabelShrink
                            }
                        }}
                        error={hasError}
                        helperText={errorText}
                        {...rest}
                    />
                </MuiPickersUtilsProvider>
            </>
        );
    }
}

const DatePicker = FormField(DatePickerWrapper);

export default withStyles(styles)(DatePicker);
